const customSelectors = {
    addMoreBtn: document.querySelector('.add-more [data-addmore-btn]'),
    allFieldsElement: document.querySelector('[data-all-fields]'),
    bulkAddToCartBtn: document.querySelector('.bulk-add-btn [data-bulk-addtocart]')
};

class customJS {
    constructor() {
        this.bulkOrderAddFields();
        this.bulkAddToCart();
    }

    /**
     * Add more fields for bulk product addition
     */
    bulkOrderAddFields(){
        customSelectors.addMoreBtn.addEventListener('click', () => {
            let formGroupElement = `
            <div class="form-group" data-item="">
            <input type="text" class="item-sku form-control" placeholder="Item #" name="sku" data-item-sku="">
            <label>
            <input type="number" class="item-quantity  form-control" name="quantity" placeholder="QTY" data-item-quantity="">
            </label>
            </div>
            `
            customSelectors.allFieldsElement.insertAdjacentHTML('beforeend',formGroupElement)

        });
    }

    /**
     * bulk product add to cart
     * inputs - SKU , quantity of product
     */
     bulkAddToCart(){
        var self = this;
        var qtyInputs = [];

        customSelectors.bulkAddToCartBtn.addEventListener('click' ,  () =>{
            let itemsElement = customSelectors.allFieldsElement.querySelectorAll('[data-item]');
            let queryURL;
            var query = ''
            itemsElement.forEach( (element , index ) => {
                let itemSku = element.querySelector('[data-item-sku]').value;
                let qty = element.querySelector('[data-item-quantity]').value;
                qty = parseInt(qty);
                if(itemSku.length > 1 )
                qtyInputs.push(qty);
                    {
                    query +=  (query.length ? ' OR ' : '')  + 'variants.sku:' + itemSku ;
                     queryURL = `/search/suggest.json?q=${query}`;
                }
            })
            this._fetchProducts(queryURL,qtyInputs)
        });
    }

    /***
     * queryURl - queryURL for fetching a multiple products based on sku using predictive search API
     * qtyInputs - quantities added per product
     */
    async _fetchProducts(queryURL,qtyInputs){
      
        var productsIdData = [];
        let gaphql_query = "";
        let items = {};
        var allItems=[];
        const response = await  fetch(queryURL, 
            { 
                    method: 'GET', 
                    headers: { 
                        'Accept':'application/json',
                        'Content-Type': 'application/json'
                    }
            })

            let data = await response.json();
          
            let products = data.resources.results.products; 
                products.forEach( product => {
                    productsIdData.push(product.id);
                    let productsIds = productsIdData;
                    let ids = '['
                    productsIds.forEach(id => {
                      ids += `"gid://shopify/Product/${id}",`;
                    })
                    ids += ']';
                    gaphql_query = `
                      nodes(ids: ${ids}) {
                        ... on Product {
                          id
                          title
                          variants(first: 1) {
                            nodes {
                              id
                              quantityAvailable
                              availableForSale
                            }
                          }
                        }
                      }
                    `;
                 });

                 let variantData = await this._fectchVariant(gaphql_query);
                 if(variantData){
                    for(let i=0 , j=0 ; i < variantData.length ; i++,j++){
                         items = {};
                         items['id'] = parseInt(variantData[i])
                         items['quantity'] = qtyInputs[j];
                         allItems.push(items)
                    }
                    this._addProduct(allItems);
               
                 }
             
    }

    /**
     * 
     * @param {*} gaphql_query - query for fetching a variant IDS based on productIDs
     * @returns 
     */
    async _fectchVariant(gaphql_query){
        let storeToken = atob(window.globalVariables.storeT);
            let varaintData = [];
            let fetchUrl = `/api/2023-04/graphql.json`;
            const response = await fetch(fetchUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept':'application/json',
                "Access-Control-Origin": "*",
                'X-Shopify-Storefront-Access-Token': storeToken
            },
            body: JSON.stringify({query : `{${gaphql_query}}`}),
            })
            
            
            const resdata = await response.json();
          
            if(resdata.errors){
                notificationEle?.updateNotification('Error', 'Specific SKU products is not available', {
                    type: 'error',
                    timeout: 2000
                });
                return false;
            } else {
                let products = resdata.data.nodes;
            
                products.forEach(product => {
                    let variantId =product.variants.nodes[0]['id'];
                    variantId = variantId.split('/');
                    variantId = variantId[variantId.length-1];
                    varaintData.push(variantId);
                })
                return varaintData;
            }
            
    }


    /**
     * 
     * @param {*} allItems - array of items
     * add product to cart and redirect to cart page  
     */
    _addProduct = (allItems) => {
        document.querySelector('[data-bulk-addtocart]').classList.add('loading');
        // console.log('add product----',allItems)
        fetch('/cart/add.js', {
            method: "post",
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({
                items: allItems
            })
        }).then(function(data) {
            // console.log(data,'data---')
            window.location.href = '/cart';
        
        }).catch(function(error) {
            console.log(error);
        });
    }

}

typeof customJS !== 'undefined' && new customJS();